import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { RadioProvider } from "@/context/RadioContext";
import Navbar from "@/components/Navbar";
import PersistentPlayer from "@/components/PersistentPlayer";
import HomePage from "@/pages/HomePage";
import BlogPage from "@/pages/BlogPage";
import PostPage from "@/pages/PostPage";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <RadioProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-background text-foreground">
          <div className="grain-overlay" aria-hidden="true" />
          <Navbar />
          <main className="pb-24">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<PostPage />} />
            </Routes>
          </main>
          <PersistentPlayer />
          <Toaster theme="dark" position="top-center" richColors />
        </div>
      </BrowserRouter>
    </RadioProvider>
  );
}

export default App;
